<template>
  <div class="box">
      <el-form autoComplete="on"
               :model="loginForm"
               :rules="loginRules"
               ref="loginForm"
               class="box-content"
               label-position="left">
        <h2 class="login-title">Reset Your Password</h2>
        <p style="font-size:18px;color:#343434;line-height:24px;margin:30px 0 35px ;">Enter the email address you used to register andwe will send you instructions on how to reset yourpassword.</p>
        <el-form-item prop="emailAddress" label="Email Address:">
          <el-input name="emailAddress" class="ipt"
                    type="text"
                    v-model="loginForm.emailAddress"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 44px;">
          <a class="loginBtn a1" style="float:left;" :loading="loading" @click="handleLogin">
            SUBMIT
          </a>
          <a @click="goCancel" style="font-size:18px;font-weight:bold;color:#346b7d;margin-left:136px;">Cancel</a>
        </el-form-item>
        <p style="font-size:18px;font-weight:bold;color:#343434;margin-bottom:10px;">Need Further Assistance?</p>
        <p style="line-height:24px;font-size:18px;color:#343434;margin-bottom:200px;">lf you no longer use the email address associatedwith your Edmund Optics account, you can eithercontact Customer Service to restore access to youraccount or Chat with us now.</p>
      </el-form>
  </div>
</template>

<script>
  import { resetPassSendEmail } from '@/api/index' ;

  const defaultlogin = {
    emailAddress: '',
  };
  export default {
    name: 'Password',

    data() {
      const emailAddress = (rule, value, callback) => {
        let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!reg.test(value)) {
          callback(new Error('Please enter the correct email address'))
        } else {
          callback()
        }
      };
      return {
        loginForm: Object.assign({}, defaultlogin),
        loginRules: {
          emailAddress: [{required: true, trigger: 'blur', validator: emailAddress}],
        },
        loading: false,
      }
    },
    methods: {
      handleLogin() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.loading = true;
            resetPassSendEmail(this.loginForm).then((res) => {
                console.log(res, 'resetPassSendEmail');
                this.loading = false
                this.$router.push({name: "Login"});
            }).catch(() => {
                this.loading = false
            });
          } else {
            return false
          }
        })
      },
      goCancel() {
        this.$router.push({name: "Login"});
      },
    }
  }
</script>

<style scoped>
  .box{
    height:100%;
    width:100%;
    overflow: auto;
    min-height: 100vh;
    position: relative;
  }
  .box-content {
    width:448px;
    position: absolute;
    left: 50%;
    top: 74px;
    transform: translateX(-50%);
    text-align:left;
  }
  .login-title {
    font-size:30px;
    font-weight:bold;
    font-family:Arial;
    color:#000;
  }
  .ipt{
    width:423px;
    height:36px;
    border: 0 !important;
    outline: none;
  }
  ::v-deep .el-input__inner {
    border-radius: 0 !important;
    border: 1px solid #e1e1e1 !important;
    background-color: #fff !important;
  }
  ::v-deep input:-internal-autofill-selected {
    background-color: #fff !important;
  }
  .loginBtn{
    width:225px;
    height:48px;
    background: #00718c;
    border-radius:6px;
    color: #ffffff;
    font-size:20px;
    font-weight:bold;
    text-align:center;
    line-height:48px;
    display:block;
  }
</style>